<template>
  <div>
    <div class="row mb-2 pe-4">
      <div class="col-lg-12 col-md-12 col-12 d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">MEGAPOS DATA</h3>
        </div>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100 my-transacions">
      <span class="mask bg-white"></span>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto mt-4">
            <div class="row">
              <strong> Item Pickup </strong>
            </div>
            <div class="row mt-3">
              <div class="col-lg-3 col-md-12 col-12">
                <div class="form-group">
                  <label class="text-bold">Branch</label>
                  <div>
                    <Multiselect
                      v-model="branch_id"
                      :options="branchs"
                      :canClear="false"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-12 col-12">
                <div class="form-group">
                  <label class="text-bold">From</label>
                  <div>
                    <Datepicker
                      :enableTimePicker="false"
                      class="date-time-dashboad"
                      v-model="from_date"
                      :format="format"
                      auto-apply
                      :clearable="false"
                      :min-date="
                        new Date(
                          new Date().setFullYear(new Date().getFullYear() - 1)
                        )
                      "
                      :max-date="new Date()"
                      @update:model-value="onChangeFromDate"
                    />
                  </div>
                </div>
              </div>
              <div class="col-lg-3 col-md-12 col-12">
                <div class="form-group">
                  <label class="text-bold"
                    >To <span class="text-danger">(Up to 31 days)</span></label
                  >
                  <div>
                    <Datepicker
                      :enableTimePicker="false"
                      class="date-time-dashboad"
                      v-model="to_date"
                      :format="format"
                      auto-apply
                      :clearable="false"
                      :min-date="from_date"
                      :max-date="
                        new Date(
                          new Date(from_date).setDate(
                            new Date(from_date).getDate() + this.totalDaySelect
                          )
                        )
                      "
                      @update:model-value="onChangeToDate"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex align-items-center mt-3">
              <div class="text-bold me-3">Search</div>
              <div style="width: 100%; max-width: 500px">
                <input
                  class="nosubmit"
                  type="search"
                  id="keyword_search"
                  v-model="searchKeyword"
                  extraClass
                  name="keyword_search"
                  placeholder="Enter receipt no, item no, item name..."
                  @keydown.enter="handleSearchEnter"
                />
              </div>
            </div>
            <div class="row mt-4 ps-3">
              <div class="col-lg-9 col-md-9 col-3 d-flex">
                <div class="dropdown">
                  <button
                    class="btn btn-secondary dropdown-toggle btn-sm"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    aria-haspopup="true"
                    :disabled="disabled"
                  >
                    Download
                  </button>
                  <ul
                    class="dropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <!-- <li>
                      <a
                        class="dropdown-item"
                        @click="exportFile('csv')"
                        href="#"
                      >
                        Export CSV
                      </a>
                    </li> -->
                    <li>
                      <a
                        class="dropdown-item"
                        @click="exportFile('xlsx')"
                        href="#"
                      >
                        Export Excel
                      </a>
                    </li>
                    <!-- <li>
                      <a
                        class="dropdown-item"
                        @click="exportFile('pdf')"
                        href="#"
                        >Export PDF</a
                      >
                    </li> -->
                  </ul>
                </div>
                <div style="margin-left: 3vh">
                  <material-button
                    class="btn-background btn-sm"
                    @click="filterData()"
                    style="width: 162.52px"
                  >
                    Run
                  </material-button>
                </div>
              </div>
            </div>
            <div class="row mt-1 ps-3">
              <div
                class="col-lg-9 col-md-12 col-12 d-flex justify-content-lg-start align-items-end"
              >
                Count: {{ totalRecords }}
              </div>
              <div class="col-lg-3 col-md-3 col-3 d-flex justify-content-end">
                <ShowHideColumn
                  :columns="columns"
                  :changeCheckbox="changeCheckbox"
                  :columnCheckedCache="columnChecked"
                  :key="key"
                />
              </div>
            </div>
            <div class="row mt-4" style="min-height: 1120px">
              <div class="col-12">
                <div class="card-custom">
                  <div class="px-0 pb-2">
                    <div class="table-responsive p-0 custom-table">
                      <table class="table align-items-center mb-0">
                        <thead>
                          <tr>
                            <th
                              class="text-center font-weight-bolder w-5"
                              v-if="columnShowed.includes('row_no')"
                            >
                              Row No
                            </th>
                            <template
                              v-for="(item, index) in headersData"
                              :key="index"
                            >
                              <th
                                class="text-center font-weight-bolder"
                                v-if="columnShowed.includes(item.field)"
                              >
                                <span
                                  :class="[
                                    !!item.hasSortBy
                                      ? 'wrapper-sortby pointer'
                                      : '',
                                    ESortDirectionSelect.idx == index + 1
                                      ? ESortDirectionSelect.direction ===
                                        ESortDirection.Desc
                                        ? 'sort-desc'
                                        : 'sort-asc'
                                      : '',
                                  ]"
                                  @click="
                                    () => {
                                      !!item.hasSortBy &&
                                        handleChangeSortColumn(index + 1);
                                    }
                                  "
                                  >{{ item.label }}</span
                                >
                              </th>
                            </template>
                          </tr>
                        </thead>
                        <tbody v-if="items.length">
                          <tr
                            v-for="(value, key) in items"
                            :key="key"
                            :id="'order-' + value.transaction_id + '-' + key"
                          >
                            <td
                              class="text-center text-xss w-5"
                              v-if="columnShowed.includes('row_no')"
                            >
                              <div class="mt-1">{{ key + 1 }}</div>
                            </td>
                            <td
                              class="text-center text-xss w-5"
                              v-if="columnShowed.includes('branch_name')"
                            >
                              {{ value.branch_name }}
                            </td>
                            <td
                              class="text-center text-xss w-15"
                              v-if="columnShowed.includes('receipt_no')"
                            >
                              {{ value.receipt_no }}
                            </td>
                            <td
                              class="text-left text-xss w-15"
                              v-if="columnShowed.includes('created_at_format')"
                            >
                              {{ value.created_at_format }}
                            </td>
                            <td
                              class="text-left text-xss w-15"
                              v-if="columnShowed.includes('item_no')"
                            >
                              {{ value.item_no }}
                            </td>
                            <td
                              class="text-center text-xss w-20"
                              v-if="columnShowed.includes('item_name')"
                            >
                              {{ value.item_name }}
                            </td>
                            <td
                              class="text-center text-xss w-5"
                              v-if="columnShowed.includes('quantity')"
                            >
                              {{ value.quantity }}
                            </td>
                            <td
                              class="text-center text-xss w-5"
                              v-if="columnShowed.includes('discount')"
                            >
                              {{ formatPrice(value.discount) }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('discount_label')"
                            >
                              {{ value.discount_label }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('promo_code')"
                            >
                              {{ value.promo_code }}
                            </td>
                            <td
                              class="text-center text-xss w-1"
                              v-if="columnShowed.includes('customer_name')"
                            >
                              {{ value.customer_name }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('phone_number')"
                            >
                              {{ value.phone_number }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('customer_email')"
                            >
                              {{ value.customer_email }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('pickup_date')"
                            >
                              {{ value.pickup_date }}
                            </td>
                            <td
                              class="text-center text-xss w-10"
                              v-if="columnShowed.includes('pickup_time')"
                            >
                              {{ value.pickup_time }}
                            </td>
                            <td
                              class="text-left text-xss w-20"
                              v-if="columnShowed.includes('remarks')"
                            >
                              <div v-html="value.remarks"></div>
                            </td>
                            <td
                              class="text-center text-xss w-20"
                              v-if="columnShowed.includes('open_request')"
                            >
                              {{ value.open_request }}
                            </td>
                            <td
                              class="text-center text-xss w-20"
                              v-if="columnShowed.includes('open_request_remark')"
                            >
                              {{ value.open_request_remark }}
                            </td>
                          </tr>
                        </tbody>
                        <tbody v-else>
                          <tr>
                            <td colspan="18" class="text-center">
                              No item available
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <pagination
                    v-if="pagination.last_page > 1"
                    :pagination="pagination"
                    :current_page="pagination.current_page"
                    :last_page="pagination.last_page"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="position-fixed top-1 end-1 z-index-2 message-success">
        <material-snackbar
          v-if="snackbar === 'danger' || snackbar === 'success'"
          title=""
          date=""
          :description="message"
          :icon="{ component: 'campaign', color: 'white' }"
          :color="snackbar"
          :close-handler="closeSnackbar"
        />
      </div>
      <material-loading :active="loaderActive" />
    </div>
    <form
      :action="`${actionDownload}/merchant/download-pickup-items-report`"
      method="POST"
    >
      <input type="hidden" name="merchantId" :value="merchantIdExport" />
      <input type="hidden" name="merchant_code" :value="merchantCode" />
      <input type="hidden" name="token" :value="token" />
      <input type="hidden" name="list_field_show" :value="columnShowed" />
      <input type="hidden" name="search_keyword" :value="searchKeyword" />
      <input type="hidden" name="from_date" :value="dateFormat(from_date)" />
      <input type="hidden" name="to_date" :value="dateFormat(to_date)" />
      <input type="hidden" name="branch_id" :value="branch_id" />
      <input type="hidden" name="checkExport" :value="checkExport" />
      <input type="hidden" name="action_export" :value="action_export" />
      <input type="hidden" name="action" value="export" />
      <input id="downloadForm" type="submit" class="d-none" />
    </form>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialLoading from "@/components/MaterialLoading.vue";
import Pagination from "@/components/Pagination.vue";
import "bootstrap/js/dist/modal";
import "@vuepic/vue-datepicker/dist/main.css";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import MaterialButton from "@/components/MaterialButton.vue";
import ShowHideColumn from "@/components/ShowHideColumn.vue";
import Datepicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import moment from "moment";
import DashboardReportService from "../../services/dashboardReport.service";
import $ from "jquery";
import TokenService from "../../services/token.service";
import CommonFunctionService from "../../services/commonFunction.service";
import { formatPrice } from "@/config/utils";

export default {
  name: "ItemPickupReport",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    Pagination,
    Multiselect,
    Datepicker,
    ShowHideColumn,
  },
  data() {
    return {
      token: TokenService.getLocalAccessToken(),
      actionDownload: process.env.VUE_APP_BASE_URL,
      merchantIdExport: localStorage.getItem("MERCHANT_ID", ""),
      merchantCode: localStorage.getItem("MERCHANT_CODE", ""),
      message: "",
      snackbar: null,
      loaderActive: false,
      searchKeyword: "",
      searchTimerId: null,
      pagination: {},
      page: 1,
      columns: [
        { label: "All", value: "all" },
        { label: "Row No", value: "row_no" },
        { label: "Branch", value: "branch_name" },
        { label: "ReceiptNo", value: "receipt_no" },
        { label: "Order DateTime", value: "created_at_format" },
        { label: "Item No", value: "item_no" },
        { label: "Item Name", value: "item_name" },
        { label: "Quantity", value: "quantity" },
        { label: "Discount", value: "discount" },
        { label: "Discount Label", value: "discount_label" },
        { label: "Promo Code", value: "promo_code" },
        { label: "Customer Name", value: "customer_name" },
        { label: "Phone Number", value: "phone_number" },
        { label: "Customer Email", value: "customer_email" },
        { label: "Pickup Date", value: "pickup_date" },
        { label: "Pickup Time", value: "pickup_time" },
        { label: "Remarks", value: "remarks" },
        { label: "Open Request", value: "open_request" },
        { label: "Open Request Remark", value: "open_request_remark" },
      ],
      from_date: new Date(new Date().getFullYear(), new Date().getMonth(), 1),
      to_date: new Date(),
      action: "list",
      action_export: "csv",
      totalRecords: 0,
      columnShowed: [],
      branchs: [],
      branch_id: 0,
      items: [],
      columnChecked: [],
      checkExport: false,
      ESortDirectionSelect: {
        idx: null,
        direction: null,
      },
      ESortDirection: {
        Asc: "asc",
        Desc: "desc",
      },
      totalDaySelect: 30,
    };
  },
  created() {
    this.getDataFilter();
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
    if (window.localStorage.getItem("PickupItemsColumn")) {
      this.columnChecked = window.localStorage
        .getItem("PickupItemsColumn")
        .split(",");
      this.key = Math.random();
    }
  },
  computed: {
    headersData() {
      return [
        {
          label: "Branch",
          field: "branch_name",
          hasSortBy: true,
        },
        {
          label: "Receipt No",
          field: "receipt_no",
          hasSortBy: true,
        },
        {
          label: "Order Date Time",
          field: "created_at_format",
          hasSortBy: true,
        },
        {
          label: "Item No",
          field: "item_no",
          hasSortBy: true,
        },
        {
          label: "Item Name",
          field: "item_name",
          hasSortBy: true,
        },
        {
          label: "Quantity",
          field: "quantity",
          hasSortBy: true,
        },
        {
          label: "Discount",
          field: "discount",
          hasSortBy: true,
        },
        {
          label: "Discount Label",
          field: "discount_label",
          hasSortBy: true,
        },
        {
          label: "Promo Code",
          field: "promo_code",
        },
        {
          label: "Customer Name",
          field: "customer_name",
          hasSortBy: true,
        },
        {
          label: "Phone Number",
          field: "phone_number",
          hasSortBy: true,
        },
        {
          label: "Customer Email",
          field: "customer_email",
          hasSortBy: true,
        },
        {
          label: "Pickup Date",
          field: "pickup_date",
          hasSortBy: true,
        },
        {
          label: "Pickup Time",
          field: "pickup_time",
          hasSortBy: true,
        },
        {
          label: "Remarks",
          field: "remarks",
          hasSortBy: true,
        },
        {
          label: "Open Request",
          field: "open_request",
          hasSortBy: false,
        },
        {
          label: "Open Request Remark",
          field: "open_request_remark", 
          hasSortBy: false,
        },
      ];
    },
  },
  methods: {
    formatPrice,

    format(date) {
      return CommonFunctionService.formatDateShow(date);
    },

    onChangeFromDate(from_date) {
      this.from_date = from_date;
      let limitDate = moment(from_date).add(this.totalDaySelect, "days");

      if (
        moment(this.to_date) > limitDate ||
        moment(this.to_date) < moment(this.from_date)
      ) {
        if (limitDate > moment()) {
          limitDate = moment();
        }

        this.to_date = limitDate;
      }
    },

    onChangeToDate(to_date) {
      this.to_date = to_date;

      // if (this.totalDaySelect) {
      // const limitDate = moment(to_date).subtract(this.totalDaySelect, 'days');

      // if (moment(this.from_date) < limitDate) {
      // this.from_date = limitDate;
      // this.onChangeSearchParameter(this.from_date, this.search_field.FROM_DATE);
      // }
      // }
    },

    exportFile(type = "csv") {
      if (this.columnShowed.length == 0) {
        this.snackbar = "danger";
        this.message = "You must select least 1 column to export file.";
        this.setTimeOutNotification();
      } else {
        this.action_export = type;
        setTimeout(() => {
          $("#downloadForm").click();
        }, 150);
      }
    },

    changeCheckbox(columnShowed) {
      this.columnShowed = columnShowed;
      window.localStorage.setItem("PickupItemsColumn", columnShowed);
    },

    filterData() {
      this.getList(this.page);
    },

    dateFormat(date) {
      if (date == null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD");
      }
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },

    handleChangeSortColumn(idx) {
      if (
        this.ESortDirectionSelect.idx &&
        this.ESortDirectionSelect.idx == idx
      ) {
        this.ESortDirectionSelect.direction =
          this.ESortDirectionSelect.direction === this.ESortDirection.Asc
            ? this.ESortDirection.Desc
            : this.ESortDirection.Asc;
      } else {
        this.ESortDirectionSelect = {
          idx: idx,
          direction: this.ESortDirection.Asc,
        };
      }

      if (this.items.length) {
        this.getList(this.page);
      }
    },

    getList(page) {
      this.totalRecords = 0;
      this.showLoader();
      var dataForm = {
        action: this.action,
        branch_id: this.branch_id,
        search_keyword: this.searchKeyword,
        from_date: this.dateFormat(this.from_date),
        to_date: this.dateFormat(this.to_date),
        action_export: this.action_export,
        checkExport: this.checkExport,
        page: page,
        sortCol: this.ESortDirectionSelect.idx,
        sortType: this.ESortDirectionSelect.direction,
      };

      DashboardReportService.getDataItemPickupReport(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.items = response.data.data.items;
            this.pagination = response.data.data;
            this.page = this.pagination.current_page;
            this.totalRecords = this.pagination.total;
            if (this.pagination.current_page > this.pagination.last_page) {
              this.page = 1;
              this.getList(this.page);
            }
            this.$router.push({
              query: Object.assign({}, this.$route.query, { page: this.page }),
            });
            this.checkExport = true;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    getDataFilter() {
      this.showLoader();
      DashboardReportService.getFilterDataTopupReport().then(
        (response) => {
          if (response.data.result.isSuccess) {
            var DataFilter = response.data.data;
            this.branchs = DataFilter.branches;
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.hideLoader();
          this.setTimeOutNotification();
        }
      );
    },

    handleSearchEnter() {
      this.getList(this.page);
    },
  },
};
</script>
<style scoped>
table thead th:not(:first-child) {
  min-width: 150px;
}

table thead th > span {
  position: relative;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}

.nosubmit-parent {
  border: none;
  padding: 0;
}

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.date-time-dashboad .dp__input_wrap {
  min-width: 200px !important;
  width: 250px;
}

.modifier-item .modifier-item-child {
  margin-left: 15px;
}

.choice-item .modifier-item {
  margin-left: 15px;
}

.choice-item .modifier-item .modifier-item-child {
  margin-left: 30px;
}
</style>
